module.exports = __webpack_public_path__ + "media/images/arrow-left-white-adb78dd93099cfe68e522c40a12f604a.svg";